import { createWithEqualityFn } from 'zustand/traditional';

type SubscriptionStreamStore = {
  nextCursor: Map<string, string>;
};

const initialState: SubscriptionStreamStore = {
  nextCursor: new Map(),
};

const useSubscriptionStreamStore =
  createWithEqualityFn<SubscriptionStreamStore>(() => initialState);

export default useSubscriptionStreamStore;

export const setNextCursor = (name: string, cursor: string) => {
  useSubscriptionStreamStore.setState((state) => {
    if (state.nextCursor.get(name) === cursor) {
      return state;
    }

    return {
      nextCursor: new Map(state.nextCursor).set(name, cursor),
    };
  });
};
